import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { MessageContent } from 'widgets/DetailsContent'
import {
  type DetailsSurveyModalStore,
  type IDetailsMessageItem,
} from '../../store/detailsSurveyModalStore'
import styles from './styles.module.scss'

const MessageRow = observer(
  ({ item, disabled }: { item: IDetailsMessageItem; disabled?: boolean }) => {
    const hasContent = Boolean(item.message) || item.attachments.length > 0

    const renderValue = () => {
      if (hasContent && !disabled) {
        return (
          <MessageContent
            type={'sms'}
            message={item.message}
            attachments={item.attachments}
            isDetailsMode
            isAccentedMessage={false}
          />
        )
      }

      return (
        <Typography
          ariaLabel={'scoreElaborationEmpty'}
          variant={'body-md-regular'}
          className={styles.placeholder}
        >
          —
        </Typography>
      )
    }

    return (
      <div className={styles.row}>
        <Typography
          ariaLabel={'messageLabel'}
          variant={'text-input-field-r'}
          className={styles.name}
        >
          {item.label}
        </Typography>
        <div className={styles.value}>{renderValue()}</div>
      </div>
    )
  }
)

export const ScoreElaborationTab = observer(({ store }: { store: DetailsSurveyModalStore }) => {
  const { scoreElaborationItems, isScoreElaborationEnabled } = store

  return (
    <div className={styles.tabContent}>
      <section className={styles.section}>
        <Typography
          ariaLabel={'scoreElaboration'}
          variant={'body-rg-medium'}
          className={styles.head}
        >
          Open-ended response
        </Typography>

        {scoreElaborationItems.map((item) => (
          <MessageRow key={item.key} item={item} disabled={!isScoreElaborationEnabled} />
        ))}
      </section>
    </div>
  )
})
